export default __webpack_public_path__ + "static/media/e.cfb99d91.svg";